import React from 'react';  
import './AboutUs.css'; // Make sure you have this CSS file  

const AboutUs = () => {  
  return (  
    <div className="about-us-container">  
      <h1>About Us</h1>  
      
      <div className="about-us-card">  
        <h2>Who We Are</h2>  
        <p>  
          We are thrilled to connect with aspiring individuals and corporate organizations to share our diverse range of services. With over ten years of experience in the maritime and oil and gas sectors,   
          Sunpet Global Enterprises was established in 2013 with a commitment to excellence.  
        </p>  
      </div>  

      <div className="about-us-card">  
        <h2>Our Operations</h2>  
        <p>  
          Initially, we focused on facilitating the supply of Automated Gas Oil (AGO) from depots in Lagos, Nigeria, to our valued customers. Our distribution network extends to prominent tank farms in Lagos,   
          Port Harcourt, and Calabar, ensuring that we cater to the fuel needs of gas stations, paint manufacturing companies, banks, and telecommunications organizations.   
          Over the years, our operations have expanded to encompass the sale and transportation of oil and gas products via both trucking and marine vessels, providing efficient and reliable service.  
        </p>  
      </div>  

      <div className="about-us-card">  
        <h2>Our Specialties</h2>  
        <p>  
          We also specialize in TTO (Tanker Take Over) and TTT (Tanker to Tanker) both for AGO and BLCO procedures in Nigerian waters, ensuring that our logistics and maritime services adhere to industry standards and regulations.   
          Additionally, we facilitate transactions to Ghana Waters under conditions such as CIF (Cost, Insurance, and Freight), TTO, and TTT to streamline the process for our clients.  
        </p>  
      </div>  

      <div className="about-us-card">  
        <h2>Our Trading Procedures</h2>  
        <p>  
          Our trading procedures are sacrosanct, as we ensure that our prospective clients are legitimate and willing to engage in business. After signing the Sales and Purchase Agreement (SPA),   
          the buyer is required to send a pre-advice, which our bank will acknowledge. This acknowledgment includes a ready and willing pre-advice to receive various bank instruments, including:  
        </p>  
        <ul>  
          <li><strong>Bank Guarantees:</strong> Providing financial assurances that enhance trust in business transactions.</li>  
          <li><strong>Blockfunds:</strong> Ensuring the required capital is securely in place for transactions.</li>  
          <li><strong>Bank Endorsed Cheques:</strong> Facilitating easier and more secure payment methods.</li>  
          <li><strong>Bank Assurance Letters:</strong> Confirming financial standing and legitimacy to streamline interactions.</li>  
        </ul>  
      </div>  

      <div className="about-us-card">  
        <h2>Our Commitment</h2>  
        <p>  
          The challenges we faced with some clients prompted us to incorporate financial services that smooth out all transactions, ensuring a hitch-free financial experience for all our customers.   
          At Sunpet Global Enterprises, we believe that everyone deserves the privilege of experiencing our superior service, and that is why we have included comprehensive information about our offerings on our website,   
          allowing you to navigate through our services easily. We are dedicated to providing exceptional value and building long-term partnerships with our clients.  
        </p>  
      </div>  
    </div>  
  );  
};  

export default AboutUs;  